import React from 'react';

const OceanMascot: React.FC<{
  style?: React.CSSProperties;
  className?: string;
}> = ({ style, className }) => (
  <svg
    viewBox="0 0 32 32"
    width="1em"
    height="1em"
    style={style}
    className={className}
  >
    <defs>
      <linearGradient id="ocean-dome" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#22d3ee" />
        <stop offset="100%" stopColor="#14b8a6" />
      </linearGradient>
      <filter id="ocean-glow">
        <feGaussianBlur stdDeviation="1" result="blur" />
        <feFlood floodColor="#22d3ee" floodOpacity="0.4" result="color" />
        <feComposite in="color" in2="blur" operator="in" result="glow" />
        <feMerge>
          <feMergeNode in="glow" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    {/* Bell / dome */}
    <path
      d="M6 16 Q6 4 16 4 Q26 4 26 16 Z"
      fill="url(#ocean-dome)"
      opacity="0.85"
      filter="url(#ocean-glow)"
    />
    {/* Inner highlight */}
    <ellipse cx="14" cy="9" rx="4" ry="2.5" fill="white" opacity="0.2" />
    {/* Eyes */}
    <circle cx="12.5" cy="12" r="1" fill="white" />
    <circle cx="19.5" cy="12" r="1" fill="white" />
    {/* Tentacles */}
    <path
      d="M9 16 Q8 22 10 26"
      fill="none"
      stroke="#f9a8d4"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M13 16 Q14 23 12 28"
      fill="none"
      stroke="#22d3ee"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M19 16 Q18 23 20 28"
      fill="none"
      stroke="#22d3ee"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M23 16 Q24 22 22 26"
      fill="none"
      stroke="#f9a8d4"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default OceanMascot;
